"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnrichByMatches = exports.getEnrichByMatch = exports.EnrichBy = exports.ENRICH_BY_MATCHES = exports.ENRICH_BY_DATA = exports.ENRICH_BY_META_LOOKUP = void 0;
require("reflect-metadata");
var ENRICH_BY_META_LOOKUP;
(function (ENRICH_BY_META_LOOKUP) {
    ENRICH_BY_META_LOOKUP["fingerprint"] = ".fingerprint";
    ENRICH_BY_META_LOOKUP["sessionId"] = ".sessionId";
    ENRICH_BY_META_LOOKUP["localId"] = ".localId";
    ENRICH_BY_META_LOOKUP["elapsed"] = ".elapsed";
    ENRICH_BY_META_LOOKUP["elapsedAtReportTime"] = ".elapsedAtReportTime";
})(ENRICH_BY_META_LOOKUP = exports.ENRICH_BY_META_LOOKUP || (exports.ENRICH_BY_META_LOOKUP = {}));
var ENRICH_BY_DATA;
(function (ENRICH_BY_DATA) {
    ENRICH_BY_DATA["localId"] = "localId";
    ENRICH_BY_DATA["user"] = "user";
    ENRICH_BY_DATA["userId"] = "userId";
    ENRICH_BY_DATA["fingerprint"] = "fingerprint";
    ENRICH_BY_DATA["timestamp"] = "timestamp";
})(ENRICH_BY_DATA = exports.ENRICH_BY_DATA || (exports.ENRICH_BY_DATA = {}));
exports.ENRICH_BY_MATCHES = Symbol('gal:enrichby');
const EnrichBy = (lookups) => (target, property) => {
    if (Object.values(ENRICH_BY_DATA).includes(property)) {
        return Reflect.metadata(exports.ENRICH_BY_MATCHES, lookups.map((lookup) => ({
            inject: property,
            lookup,
        })))(target, property);
    }
    else {
        throw new Error(`Could not add enrichment for property '${property}' on ${target.constructor.name}`);
    }
};
exports.EnrichBy = EnrichBy;
const getEnrichByMatch = (dto, property) => {
    return Reflect.getMetadata(exports.ENRICH_BY_MATCHES, dto, property);
};
exports.getEnrichByMatch = getEnrichByMatch;
const getEnrichByMatches = (dto) => {
    return Reflect.getOwnMetadata(exports.ENRICH_BY_MATCHES, dto);
};
exports.getEnrichByMatches = getEnrichByMatches;
